export class NameDisplayValInteger {
  public Name: string;
  public Display: string;
  public Value: number;

  public constructor(itemName?: string, itemDisplay?: string, itemValue?: number) {
    if (itemName == null || itemName == undefined) {
      this.Name = '';
    } else {
      this.Name = itemName;
    }
    if (itemDisplay == null || itemDisplay == undefined) {
      this.Display = '';
    } else {
      this.Display = itemDisplay;
    }

    if (itemValue == null || itemValue == undefined) {
      this.Value = null;
    } else {
      this.Value = itemValue;
    }
  }
}
